.base {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	flex-shrink: 0;
	height: var(--parrot-chat-header-height);
	padding: 0 12px;
	background: var(--parrot-chat-bg);
	border-bottom: 1px solid transparent;
	transition: border-color 0.15s, box-shadow 0.15s;
	position: relative;
	z-index: 2;
}

.scrolled {
	border-bottom-color: var(--parrot-chat-border);
	box-shadow: var(--parrot-chat-header-shadow);
}

.left {
	display: flex;
	align-items: center;
	gap: 4px;
	flex: 1;
	min-width: 0;
}

.title {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	padding: 0 4px;
	font-size: var(--parrot-chat-font-size-md);
	font-weight: var(--parrot-chat-font-weight-medium);
	color: var(--parrot-chat-text-secondary);
}

/* Title acts as the trigger for the Favourite/Rename/Delete menu. */
.titleBtn {
	display: flex;
	align-items: center;
	gap: 3px;
	max-width: 100%;
	min-width: 0;
	height: 30px;
	padding: 0 6px 0 8px;
	background: transparent;
	border: none;
	border-radius: var(--parrot-chat-radius);
	color: var(--parrot-chat-text);
	font-family: inherit;
	font-size: var(--parrot-chat-font-size-md);
	font-weight: var(--parrot-chat-font-weight-medium);
	cursor: pointer;
	transition: background 0.12s;
}

.titleBtn:hover,
.titleBtn[aria-expanded="true"] {
	background: var(--parrot-chat-menu-hover);
}

.titleText {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.titleBtn svg {
	width: 16px;
	height: 16px;
	flex-shrink: 0;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
	color: var(--parrot-chat-text-muted);
}

.renameInput {
	flex: 1;
	min-width: 0;
	height: 30px;
	box-sizing: border-box;
	padding: 0 8px;
	background: var(--parrot-chat-bg);
	border: 1px solid var(--parrot-chat-accent);
	border-radius: var(--parrot-chat-radius);
	color: var(--parrot-chat-text);
	font-family: inherit;
	font-size: var(--parrot-chat-font-size-md);
	font-weight: var(--parrot-chat-font-weight-medium);
	outline: none;
	box-shadow: 0 0 0 3px var(--parrot-chat-accent-glow);
}

.actions {
	display: flex;
	align-items: center;
	gap: 4px;
	flex-shrink: 0;
}

.iconBtn {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	padding: 0;
	background: transparent;
	border: none;
	border-radius: var(--parrot-chat-radius);
	color: var(--parrot-chat-text-muted);
	cursor: pointer;
	transition: color 0.12s, background 0.12s;
}

.iconBtn:hover {
	color: var(--parrot-chat-text);
	background: var(--parrot-chat-menu-hover);
}

.iconBtn svg {
	width: 18px;
	height: 18px;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
}

.shareBtn {
	display: flex;
	align-items: center;
	height: 30px;
	padding: 0 14px;
	background: transparent;
	border: 1px solid var(--parrot-chat-border-strong);
	border-radius: 999px;
	color: var(--parrot-chat-text);
	font-family: inherit;
	font-size: var(--parrot-chat-font-size-sm);
	font-weight: var(--parrot-chat-font-weight-medium);
	cursor: pointer;
	transition: background 0.12s, border-color 0.12s;
}

.shareBtn:hover {
	background: var(--parrot-chat-menu-hover);
	border-color: var(--parrot-chat-text-muted);
}
